import { render, staticRenderFns } from "./modify-principal.vue?vue&type=template&id=42396422&scoped=true"
import script from "./modify-principal.vue?vue&type=script&lang=ts"
export * from "./modify-principal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42396422",
  null
  
)

export default component.exports